import makeStyles from '@mui/styles/makeStyles';

const usePopupStyles = makeStyles((theme) => ({
    closeButton: {
        backgroundColor: theme.palette.primary.soft,
        borderRadius: 10,
        marginRight: '0 !important',

        '&:hover': {
            backgroundColor: theme.palette.primary.softHover
        }
    },
    root: {
        height: '90%'
    },
    r2: {
        [theme.breakpoints.down('md')]: {
            borderRadius: 0
        }
    },
    content: {
        minHeight: '5rem'
    },
    titleWrapper: {
        width: '100%',
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'space-between'
    }
}));

export default usePopupStyles;
